import { Button } from '@/components/ui/button';

/** Development-only, isolated preview: no real patient/organization identifiers in the URL. */
export function AssistantPreviewLink() {
  if (!import.meta.env.DEV) return null;
  return (
    <Button asChild size="sm" variant="outline">
      <a target="_blank" rel="noreferrer" href="/assistant-preview.html">
        Preview assistant workbench
      </a>
    </Button>
  );
}
